define('OutSystems/ReactWidgets/DropdownNative',["require", "exports", "tslib", "OutSystems/ClientRuntime/DataConversion", "OutSystems/ClientRuntime/DataTypes", "OutSystems/ReactView/Widget", "react"], function (require, exports, tslib_1, DataConversion_1, DataTypes_1, Widget_1, React) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.DropdownNative = void 0;
    var DropdownNative = (function (_super) {
        tslib_1.__extends(DropdownNative, _super);
        function DropdownNative(props, context) {
            var _this = _super.call(this, props, context) || this;
            _this.selectedValue = null;
            return _this;
        }
        DropdownNative_1 = DropdownNative;
        Object.defineProperty(DropdownNative.prototype, "variable", {
            get: function () {
                return this.props.variable;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DropdownNative.prototype, "isMandatory", {
            get: function () {
                return this.props.mandatory;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DropdownNative.prototype, "inputedValue", {
            get: function () {
                return this.isValueInList(this.selectedValue) ? this.selectedValue : null;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DropdownNative.prototype, "inputedValueValidity", {
            get: function () {
                var variableValue = this.isValueInList(this.selectedValue);
                var validity = {
                    valid: variableValue,
                    badInput: false,
                };
                return validity;
            },
            enumerable: false,
            configurable: true
        });
        DropdownNative.prototype.componentDidMount = function () {
            this.setVariable();
        };
        DropdownNative.prototype.componentDidUpdate = function () {
            this.setVariable();
        };
        DropdownNative.prototype.isValueInList = function (value) {
            if (this.props.list && this.props.list.length > 0) {
                for (var i = 0; i < this.props.list.length; i++) {
                    var itemValue = this.props.values(this.props.list.getItem(i));
                    if (DataTypes_1.equals(itemValue, value)) {
                        return true;
                    }
                }
            }
            return false;
        };
        DropdownNative.prototype.setVariable = function () {
            if (this.props.list && this.props.list.length > 0) {
                var valueFound = this.isValueInList(this.variable.value);
                if (!valueFound && !this.isEmptyValueDefined()) {
                    var newValue = this.props.values(this.props.list.getItem(0));
                    if (!DataTypes_1.equals(newValue, this.variable.value)) {
                        this.variable.value = newValue;
                        if (this.props.onChange) {
                            this.props.onChange();
                        }
                    }
                }
            }
        };
        DropdownNative.prototype.isEmptyValueDefined = function () {
            return this.props.emptyValue && this.props.emptyValue.length > 0;
        };
        DropdownNative.prototype.getSelectedValueAndOptions = function () {
            var selectedValue = 0;
            var options = [];
            if (this.isEmptyValueDefined()) {
                selectedValue = DropdownNative_1.EmptyValue;
                options.push(React.createElement("option", { key: DropdownNative_1.EmptyValue, value: DropdownNative_1.EmptyValue }, this.props.emptyValue));
            }
            if (this.props.list && this.props.list.length > 0) {
                for (var i = 0; i < this.props.list.length; i++) {
                    var item = this.props.list.getItem(i);
                    if (DataTypes_1.equals(this.variable.value, this.props.values(item))) {
                        selectedValue = i;
                        this.selectedValue = this.variable.value;
                    }
                    var label = DataConversion_1.JSConversions.convertTo(this.props.labels(item), DataTypes_1.DataTypes.Text);
                    options.push(React.createElement("option", { key: i, value: i }, label));
                }
            }
            return { selectedValue: selectedValue, options: options };
        };
        DropdownNative.prototype.handleChange = function (event) {
            var index = parseInt(event.target.value, 10);
            var value = index >= 0
                ? this.props.values(this.props.list.getItem(index))
                : DataConversion_1.JSConversions.convertTo(null, this.variable.type);
            this.variable.value = value;
            this.selectedValue = value;
            if (this.props.onChange) {
                this.props.onChange();
            }
        };
        DropdownNative.prototype.render = function () {
            var dropdownDivAttributes = {
                id: this.getId() + "-container",
                className: DropdownNative_1.DropdownContainer + (this.props.enabled ? "" : " " + DropdownNative_1.DropdownDisabled),
                "data-dropdown": "",
            };
            var nativeDropdownAttributes = {
                className: DropdownNative_1.DropdownDisplay + " " + this.props.style,
                onChange: this.handleChange.bind(this),
                disabled: !this.props.enabled,
                required: this.props.mandatory,
                "aria-disabled": !this.props.enabled,
            };
            this.fillWithBuiltinProperties(dropdownDivAttributes);
            var _a = this.getSelectedValueAndOptions(), selectedValue = _a.selectedValue, options = _a.options;
            var selectStyle = dropdownDivAttributes.style;
            return (React.createElement("div", tslib_1.__assign({}, dropdownDivAttributes, { style: undefined }),
                React.createElement("select", tslib_1.__assign({}, nativeDropdownAttributes, { id: this.getId(), style: selectStyle, value: selectedValue }), options),
                this.createValidationElement()));
        };
        var DropdownNative_1;
        DropdownNative.DropdownContainer = "dropdown-container";
        DropdownNative.DropdownDisplay = "dropdown-display";
        DropdownNative.DropdownDisabled = "dropdown-disabled";
        DropdownNative.EmptyValue = -1;
        DropdownNative = DropdownNative_1 = tslib_1.__decorate([
            Widget_1.WidgetSpec
        ], DropdownNative);
        return DropdownNative;
    }(Widget_1.InputWithVariableWidget));
    exports.DropdownNative = DropdownNative;
});
//# sourceMappingURL=DropdownNative.js.map;
